

// wait until DOM is ready
document.addEventListener("DOMContentLoaded", function (event) {

  // wait until window is loaded - all images, styles-sheets, fonts, links, and other media assets
  window.onload = function () {

    // waits til next tick render to run code (prevents running in the middle of render tick)
    window.requestAnimationFrame(function () {
       var animationStarted = false;
      var animationTimeline;

      // Add an event listener to the "popup-btn" button
      document
        .getElementById("popup-btn")
        .addEventListener("click", function () {
          // Set "animationStarted" to true when the button is clicked
          animationStarted = true;
          // Start the animation only if "animationStarted" is true
          if (animationStarted) {
            startAnimation();
          }
        });

      // Add an event listener to the "hide-btn" button
        document.getElementById("hide-button").addEventListener("click", function () {
          // Stop the animation when the "hide-btn" is clicked
          killAnimation();
        });

      function startAnimation() {




      //this is just an example plugin that allows us to animate a "blur" property like gsap.to(target, {blur:10}) and it'll feed that value to this plugin which will do all the necessary calculations to add/update a blur() value in the CSS "filter" property (in browsers that support it). We wrap it in an iife just so that we can declare some local variables in a private scope at the top.
      (function () {
        const blurProperty = gsap.utils.checkPrefix("filter"),
          blurExp = /blur\((.+)?px\)/,
          getBlurMatch = target => (gsap.getProperty(target, blurProperty) || "").match(blurExp) || [];

        gsap.registerPlugin({
          name: "blur",
          get(target) {
            return +(getBlurMatch(target)[1]) || 0;
          },
          init(target, endValue) {
            let data = this,
              filter = gsap.getProperty(target, blurProperty),
              endBlur = "blur(" + endValue + "px)",
              match = getBlurMatch(target)[0],
              index;
            if (filter === "none") {
              filter = "";
            }
            if (match) {
              index = filter.indexOf(match);
              endValue = filter.substr(0, index) + endBlur + filter.substr(index + match.length);
            } else {
              endValue = filter + endBlur;
              filter += filter ? " blur(0px)" : "blur(0px)";
            }
            data.target = target;
            data.interp = gsap.utils.interpolate(filter, endValue);
          },
          render(progress, data) {
            data.target.style[blurProperty] = data.interp(progress);
          }
        });
      })();



      var IntroAnim = gsap.timeline({ paused: true });
      IntroAnim
        .set("#video-container", {
          autoAlpha: 1
        })
        .set("#glassphoto", {
          autoAlpha: 1, y: "100vh",
        })
        .set("#glassphotoBack", {
          autoAlpha: 0, y: 0, x: 0
        })

        .fromTo("#animation-heading", {
          blur: 19, scale: 1.1, ease: "none", autoAlpha: 1
        }, {
          scale: 1, duration: 2, blur: 0,
        }, 0)

        .to("#glassphoto", {
          duration: 2.6,
          y: 0, x: 0
        }, 3)
        .to("#animation-heading", { duration: 2.6, y: "-100vh" }, 3)
        .to("#glassphoto", {
          duration: 2.6,
          scaleX: 16, scaleY: 16,
          autoAlpha: 0, y: "-33%",
          x: "-100%", ease: "none",
        }, 5.6)
        .to("#glassphotoBack", {
          duration: 2.6,
          scaleX: 16, scaleY: 16,
          y: "-33%", autoAlpha: 0.60,
          x: "-100%", ease: "none",
        }, 5.6)


        .addLabel("videoCont", 1)
        .to("#videoItemInner", {
          duration: 3.4,
          autoAlpha: 1,
          scaleX: 1.4,
          scaleY: 1.4,
          transformOrigin: 'center'
        }, 7)
        .to(".main-thx", { autoAlpha: 0, display: "none" })
        .to("button.mbtn,button.mbtn-center", { duration: .5, autoAlpha: 1, stagger: .12 }, "-=1")
        .timeScale(1).play()


      gsap.to(".content-item.active", {
        display: "block",
        opacity: 1
      });

      var outTL = gsap.timeline();
      var inTL;

      $(".mbtn").on("click", function () {


        $(".mbtn.active").removeClass("active");
        $(this).addClass("active");
        IntroAnim.kill();


        const toActive = $(this).attr("data-active");

        inTL = gsap.timeline();

        if (outTL && !outTL.isActive()) {
          outTL
            .to(".content-item.active", { duration: .2, autoAlpha: 0 })
            .to(".content-item.active #videoItemInner", { autoAlpha: 0 })


          if (inTL) {
            inTL.kill();
          }
        }

        outTL.eventCallback("onComplete", function () {
          $(".content-item.active").removeClass("active");
          $(toActive).addClass("active");


          inTL = gsap.timeline();

          inTL
            //.set(".content-item.active .content-item.intro, .content-item.active #glassphoto, .content-item.active #glassphotoBack, .content-item.active #video-container, .content-item.active #videoItemInner", { clearProps: 'all' })

            .set(".content-item.active .content-item.intro", { dispay: "none" })
            .set(".content-item.active #videoItemInner", {
              display: "block",
              autoAlpha: 0,
              scaleX: .85,
              scaleY: .85
            })//"=-.4"
            .set(".content-item.active #glassphoto, .content-item.active #glassphotoBack ", {
              scaleX: 1, scaleY: 1, autoAlpha: 1, x: 0, y: "100vh"
            })
            .set(".content-item.active #glassphotoBack ", {
              scaleX: 1, scaleY: 1, autoAlpha: 0, x: 0, y: "100vh",
            })

            .to(".content-item.active", { autoAlpha: 1 }, 0)
            .to(".content-item.active #video-container",
              { autoAlpha: 1 }
              , "=-.4")
            .to(".content-item.active #video-container", {
              duration: 4, autoAlpha: 1,
            }, 3)

            .to(".content-item.active #glassphoto", {
              duration: 2.6,
              autoAlpha: 1, x: 0, y: 0,
            }, 2)
            .to(".content-item.active #glassphotoBack", {
              duration: 2.6,
              autoAlpha: 0, x: 0, y: 0,
            }, 2)


            .to(".content-item.active #glassphoto", {
              duration: 4.4,
              scaleX: 18, scaleY: 18, x: "-160%", y: "-43%", autoAlpha: 0, ease: "none",
            }, 5.4)//-8
            .to(".content-item.active #glassphotoBack", {
              duration: 4.4,
              scaleX: 18, scaleY: 18, autoAlpha: .60, x: "-160%", y: "-43%", ease: "none",
            }, 5.4)
            .to(".content-item.active #videoItemInner", {
              duration: 3.4,
              autoAlpha: 1,
              scaleX: 1.4,
              scaleY: 1.4,
              transformOrigin: 'center',

            }, 7.5) //6.4
            .timeScale(1)
        });
      });
      }


      /*
            const buttons = gsap.utils.toArray(".mbtn");
            buttons.forEach((item) => {
              //  let span = item.querySelector(".inuse");
              let tl = gsap.timeline({ paused: true });
      
              tl.to(".inuse", { opacity: 1 });
              //  tl.set(span, { yPercent: 150 });
              // tl.to(span, { duration: 0.2, yPercent: 0 });
      
              item.addEventListener("mouseenter", () => tl.play(0));
            });
      */


function killAnimation() {
          // Check if the animation timeline exists and if it's active
          if (animationTimeline && animationTimeline.isActive()) {
            // Kill the animation and set animationStarted to false
            animationTimeline.kill();
            animationStarted = false;
          }
        }
      //end loading
    });

  };

});



// // wait until DOM is ready
// document.addEventListener("DOMContentLoaded", function (event) {
//   // wait until window is loaded - all images, styles-sheets, fonts, links, and other media assets
//   window.onload = function () {
//     // waits til next tick render to run code (prevents running in the middle of render tick)
//     window.requestAnimationFrame(function () {
//       var animationStarted = false;
//       var animationTimeline;

//       // Add an event listener to the "popup-btn" button
//       document
//         .getElementById("popup-btn")
//         .addEventListener("click", function () {
//           // Set "animationStarted" to true when the button is clicked
//           animationStarted = true;
//           // Start the animation only if "animationStarted" is true
//           if (animationStarted) {
//             startAnimation();
//           }
//         });

//       // Add an event listener to the "hide-btn" button
//         document.getElementById("hide-button").addEventListener("click", function () {
//           // Stop the animation when the "hide-btn" is clicked
//           killAnimation();
//         });

//       function startAnimation() {
//         //this is just an example plugin that allows us to animate a "blur" property like gsap.to(target, {blur:10}) and it'll feed that value to this plugin which will do all the necessary calculations to add/update a blur() value in the CSS "filter" property (in browsers that support it). We wrap it in an iife just so that we can declare some local variables in a private scope at the top.
//         (function () {
//           const blurProperty = gsap.utils.checkPrefix("filter"),
//             blurExp = /blur\((.+)?px\)/,
//             getBlurMatch = (target) =>
//               (gsap.getProperty(target, blurProperty) || "").match(blurExp) ||
//               [];

//           gsap.registerPlugin({
//             name: "blur",
//             get(target) {
//               return +getBlurMatch(target)[1] || 0;
//             },
//             init(target, endValue) {
//               let data = this,
//                 filter = gsap.getProperty(target, blurProperty),
//                 endBlur = "blur(" + endValue + "px)",
//                 match = getBlurMatch(target)[0],
//                 index;
//               if (filter === "none") {
//                 filter = "";
//               }
//               if (match) {
//                 index = filter.indexOf(match);
//                 endValue =
//                   filter.substr(0, index) +
//                   endBlur +
//                   filter.substr(index + match.length);
//               } else {
//                 endValue = filter + endBlur;
//                 filter += filter ? " blur(0px)" : "blur(0px)";
//               }
//               data.target = target;
//               data.interp = gsap.utils.interpolate(filter, endValue);
//             },
//             render(progress, data) {
//               data.target.style[blurProperty] = data.interp(progress);
//             },
//           });
//         })();

//         var IntroAnim = gsap.timeline({ paused: true });

//         IntroAnim.set("#video-container", {
//           autoAlpha: 1,
//         })
//           .set("#glassphoto", {
//             autoAlpha: 1,
//             y: "100vh",
//           })
//           .set("#glassphotoBack", {
//             autoAlpha: 0,
//             y: 0,
//             x: 0,
//           })

//           .fromTo(
//             "#animation-heading",
//             {
//               blur: 19,
//               scale: 1.1,
//               ease: "none",
//               autoAlpha: 1,
//             },
//             {
//               scale: 1,
//               duration: 2,
//               blur: 0,
//             },
//             0
//           )

//           .to(
//             "#glassphoto",
//             {
//               duration: 2.6,
//               y: 0,
//               x: 0,
//             },
//             3
//           )
//           .to("#animation-heading", { duration: 2.6, y: "-100vh" }, 3)
//           .to(
//             "#glassphoto",
//             {
//               duration: 2.6,
//               scaleX: 16,
//               scaleY: 16,
//               autoAlpha: 0,
//               y: "-33%",
//               x: "-100%",
//               ease: "none",
//             },
//             5.6
//           )
//           .to(
//             "#glassphotoBack",
//             {
//               duration: 2.6,
//               scaleX: 16,
//               scaleY: 16,
//               y: "-33%",
//               autoAlpha: 0.6,
//               x: "-100%",
//               ease: "none",
//             },
//             5.6
//           )

//           .addLabel("videoCont", 1)
//           .to(
//             "#videoItemInner",
//             {
//               duration: 3.4,
//               autoAlpha: 1,
//               scaleX: 1.4,
//               scaleY: 1.4,
//               transformOrigin: "center",
//             },
//             7
//           )
//           .to(".main-thx", { autoAlpha: 0, display: "none" })
//           .to(
//             "button.mbtn,button.mbtn-center",
//             { duration: 0.5, autoAlpha: 1, stagger: 0.12 },
//             "-=1"
//           )
//           .timeScale(1)
//           .play();

//         gsap.to(".content-item.active", {
//           display: "block",
//           opacity: 1,
//         });

//         var outTL = gsap.timeline();
//         var inTL;

//         $(".mbtn").on("click", function () {
//           $(".mbtn.active").removeClass("active");
//           $(this).addClass("active");
//           IntroAnim.kill();

//           const toActive = $(this).attr("data-active");

//           inTL = gsap.timeline();

//           if (outTL && !outTL.isActive()) {
//             outTL
//               .to(".content-item.active", { duration: 0.2, autoAlpha: 0 })
//               .to(".content-item.active #videoItemInner", { autoAlpha: 0 });
//             if (inTL) {
//               inTL.kill();
//             }
//           }

//           outTL.eventCallback("onComplete", function () {
//             $(".content-item.active").removeClass("active");
//             $(toActive).addClass("active");

//             inTL = gsap.timeline();

//             inTL
//               //.set(".content-item.active .content-item.intro, .content-item.active #glassphoto, .content-item.active #glassphotoBack, .content-item.active #video-container, .content-item.active #videoItemInner", { clearProps: 'all' })

//               .set(".content-item.active .content-item.intro", {
//                 dispay: "none",
//               })
//               .set(".content-item.active #videoItemInner", {
//                 display: "block",
//                 autoAlpha: 0,
//                 scaleX: 0.85,
//                 scaleY: 0.85,
//               }) //"=-.4"
//               .set(
//                 ".content-item.active #glassphoto, .content-item.active #glassphotoBack ",
//                 {
//                   scaleX: 1,
//                   scaleY: 1,
//                   autoAlpha: 1,
//                   x: 0,
//                   y: "100vh",
//                 }
//               )
//               .set(".content-item.active #glassphotoBack ", {
//                 scaleX: 1,
//                 scaleY: 1,
//                 autoAlpha: 0,
//                 x: 0,
//                 y: "100vh",
//               })

//               .to(".content-item.active", { autoAlpha: 1 }, 0)
//               .to(
//                 ".content-item.active #video-container",
//                 { autoAlpha: 1 },
//                 "=-.4"
//               )
//               .to(
//                 ".content-item.active #video-container",
//                 {
//                   duration: 4,
//                   autoAlpha: 1,
//                 },
//                 3
//               )

//               .to(
//                 ".content-item.active #glassphoto",
//                 {
//                   duration: 2.6,
//                   autoAlpha: 1,
//                   x: 0,
//                   y: 0,
//                 },
//                 2
//               )
//               .to(
//                 ".content-item.active #glassphotoBack",
//                 {
//                   duration: 2.6,
//                   autoAlpha: 0,
//                   x: 0,
//                   y: 0,
//                 },
//                 2
//               )

//               .to(
//                 ".content-item.active #glassphoto",
//                 {
//                   duration: 4.4,
//                   scaleX: 18,
//                   scaleY: 18,
//                   x: "-160%",
//                   y: "-43%",
//                   autoAlpha: 0,
//                   ease: "none",
//                 },
//                 5.4
//               ) //-8
//               .to(
//                 ".content-item.active #glassphotoBack",
//                 {
//                   duration: 4.4,
//                   scaleX: 18,
//                   scaleY: 18,
//                   autoAlpha: 0.6,
//                   x: "-160%",
//                   y: "-43%",
//                   ease: "none",
//                 },
//                 5.4
//               )
//               .to(
//                 ".content-item.active #videoItemInner",
//                 {
//                   duration: 3.4,
//                   autoAlpha: 1,
//                   scaleX: 1.4,
//                   scaleY: 1.4,
//                   transformOrigin: "center",
//                 },
//                 7.5
//               ) //6.4
//               .timeScale(1);
//           });
//         });
//       }

//        function killAnimation() {
//           // Check if the animation timeline exists and if it's active
//           if (animationTimeline && animationTimeline.isActive()) {
//             // Kill the animation and set animationStarted to false
//             animationTimeline.kill();
//             animationStarted = false;
//           }
//         }
//       //end loading
//     });
//   };
// });
